import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '@components/Card';
import MaxProductLabel from './MaxProductLabel';

const Container = styled(Card)`
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(10, 8)};
`;

const Subtitle = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold}
  color: ${({ theme }) => theme.colors.textPrimary};
  display: inline;
`;

const Texts = styled.div`
  margin: auto 0;
`;

function ProductQuantity({ productMaxQuantity, children }) {
  return (
    <Container>
      <Texts>
        <Subtitle>Unidades</Subtitle>
        {Boolean(productMaxQuantity) && (
          <MaxProductLabel productMaxQuantity={productMaxQuantity} />
        )}
      </Texts>
      {children}
    </Container>
  );
}

ProductQuantity.propTypes = {
  children: PropTypes.element,
  productMaxQuantity: PropTypes.number,
};

export default ProductQuantity;
